import PropTypes from "prop-types";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";

const SelectListComponent = ({children, setState, state, variants, className, isFont, tab}) => {
  const store = useEditorPanelButtonStore();

  return (
    <ul className={`select__list ${(store.isOpenModal !== tab) ? 'select__list-hide' : ''}`}>
      {children}
      {variants.map(variant =>
        <li key={variant} value={variant}
            style={isFont && {fontFamily: variant}}
            className={`select__variant ${variant === state ? 'select__variant-active' : ''} ${className}`}
            onClick={() => setState(variant)}>
          {variant}
        </li>
      )}
    </ul>
  )
}

SelectListComponent.propTypes = {
  children: PropTypes.node,
  variants: PropTypes.arrayOf(PropTypes.string).isRequired,
  state: PropTypes.string.isRequired,
  setState: PropTypes.func.isRequired,
  className: PropTypes.string,
  tab: PropTypes.string,
  isFont: PropTypes.bool,
};

export default SelectListComponent;
